import React, { Component } from 'react'
import styled from 'styled-components'

import { Grid, Row } from 'react-flexbox-grid'
import { ShadowBox } from '@ubiwherenpm/adene-ui-components'

import ChangeIcon from './images/change.component.svg'
import EditIcon from '../Svg/ic-editar.svg'
import { generateMediaUrl, unitCurrency, pricesCurrency } from 'utils'

export const Eletricity = ({
  electricityConsumption,
  prices,
  timeCycle,
  entity,
  className,
}) => {
  return (
    <EletricityRow>
      <EletricityEntityCol className={className}>
        <ResultLabel el>Eletricidade</ResultLabel>
        {entity && <Entity src={entity.logo} alt={entity.name} />}
      </EletricityEntityCol>
      <NumberysCol>
        {electricityConsumption && (
          <Numberyx style={{ marginBottom: 12 }}>
            <NumberyLabel>Consumo</NumberyLabel>
            <Price>
              {Number(electricityConsumption).toFixed(0) || '---'}{' '}
              <Unit>kWh/ano</Unit>
            </Price>
          </Numberyx>
        )}
        <Numberyx>
          <NumberyLabel>Termo Potência</NumberyLabel>
          <Price>
            {pricesCurrency(prices.electricity.termo_fixo) || '---'}{' '}
            <Unit>€/dia</Unit>
          </Price>
        </Numberyx>
        <Numberyx style={{ marginTop: 12 }}>
          <NumberyLabel>Energia</NumberyLabel>
          {timeCycle === 's' && (
            <Price>
              {`${pricesCurrency(prices.electricity.cheia) || '---'}`}{' '}
              <Unit>€/kWh</Unit>
            </Price>
          )}
        </Numberyx>
        {timeCycle === 'b' && (
          <NumberyxSmall>
            <NumberyLabelSmall>Fora do Vazio</NumberyLabelSmall>
            <Price>
              {pricesCurrency(prices.electricity.cheia) || '---'}{' '}
              <Unit>€/kWh</Unit>
            </Price>
          </NumberyxSmall>
        )}
        {timeCycle !== 's' && (
          <NumberyxSmall>
            <NumberyLabelSmall>Vazio</NumberyLabelSmall>
            <Price>
              {pricesCurrency(prices.electricity.vazio) || '---'}{' '}
              <Unit>€/kWh</Unit>
            </Price>
          </NumberyxSmall>
        )}
        {timeCycle !== 'b' && timeCycle !== 's' && (
          <NumberyxSmall>
            <NumberyLabelSmall>Ponta</NumberyLabelSmall>
            <Price>
              {pricesCurrency(prices.electricity.ponta) || '---'}{' '}
              <Unit>€/kWh</Unit>
            </Price>
          </NumberyxSmall>
        )}
        {timeCycle !== 'b' && timeCycle !== 's' && (
          <NumberyxSmall>
            <NumberyLabelSmall>Cheias</NumberyLabelSmall>
            <Price>
              {pricesCurrency(prices.electricity.cheia) || '---'}{' '}
              <Unit>€/kWh</Unit>
            </Price>
          </NumberyxSmall>
        )}
      </NumberysCol>
    </EletricityRow>
  )
}

export const Gas = ({ gasConsumption, prices, entity, className }) => {
  return (
    <GasRow>
      <GasEntityCol className={className}>
        <ResultLabel ga>Gás Natural</ResultLabel>
        {entity && <Entity src={entity.logo} alt={entity.name} />}
      </GasEntityCol>
      <NumberysCol>
        {gasConsumption && (
          <Numberyx style={{ marginBottom: 12 }}>
            <NumberyLabel>Consumo</NumberyLabel>
            <Price>
              {Number(gasConsumption).toFixed(0) || '---'} <Unit>kWh/ano</Unit>
            </Price>
          </Numberyx>
        )}
        <Numberyx>
          <NumberyLabel>Termo Fixo</NumberyLabel>
          <Price>
            {pricesCurrency(prices.gas.termo_fixo) || '---'} <Unit>€/dia</Unit>
          </Price>
        </Numberyx>
        <Numberyx style={{ marginTop: 12 }}>
          <NumberyLabel>Energia</NumberyLabel>
          <Price>
            {pricesCurrency(prices.gas.termo_energia) || '---'}{' '}
            <Unit>€/kWh</Unit>
          </Price>
        </Numberyx>
      </NumberysCol>
    </GasRow>
  )
}

export default class TopResult extends Component {
  handleChangeSimulationData() {
    const { router, changeSimulationData } = this.props

    changeSimulationData()
    router.push('/')
  }

  render() {
    let {
      annualBilling,
      electricityPriceList,
      gasPriceList,
      simulationCode,
      hasSimulation,
      error,
      onClickToSave,
      onClickToChangePrices,
    } = this.props

    let entity

    if (electricityPriceList) {
      entity = electricityPriceList.entity

      if (entity) {
        entity.logo = generateMediaUrl(entity.hi_res_logo)
      }
    }

    if (gasPriceList) {
      entity = gasPriceList.entity

      if (entity) {
        entity.logo = generateMediaUrl(entity.hi_res_logo)
      }
    }

    return (
      <Wrapper noSimulation={!hasSimulation}>
        <Container fluid>
          <FiltersList noSimulation={!hasSimulation}>
            <Scrollable noSimulation={!hasSimulation}>
              <Flexed>
                <GreyCol noSimulation={!hasSimulation}>
                  <Simulation>
                    <SimulationNumber noSimulation={!hasSimulation}>
                      <ChangeData
                        onClick={() => this.handleChangeSimulationData()}>
                        {' '}
                        <BackButton>&#60;</BackButton> Alterar dados da
                        simulação
                      </ChangeData>
                      <SimulationLabel>simulação</SimulationLabel>
                      <SimulationNumbery>#{simulationCode}</SimulationNumbery>
                    </SimulationNumber>
                    {hasSimulation && (
                      <SimulationTitle>
                        <Title>O seu tarifário atual</Title>
                      </SimulationTitle>
                    )}
                  </Simulation>
                  {hasSimulation && (
                    <FaturaCol>
                      <TitleLabel>Fatura de Energia *</TitleLabel>
                      <Numbery>
                        {annualBilling && unitCurrency(annualBilling)} €/ano
                      </Numbery>
                      <SmallNumber>
                        {annualBilling && unitCurrency(annualBilling / 12)}{' '}
                        €/mês
                      </SmallNumber>
                    </FaturaCol>
                  )}

                  {!hasSimulation && (
                    <NoSimTitle
                      grey
                      dangerouslySetInnerHTML={{ __html: error }}
                    />
                  )}
                </GreyCol>

                {electricityPriceList && (
                  <FlexedElectricity
                    {...this.props}
                    entity={electricityPriceList.entity}
                  />
                )}
                {gasPriceList && (
                  <FlexedGas {...this.props} entity={gasPriceList.entity} />
                )}
              </Flexed>
            </Scrollable>
            <ChangeCol noSimulation={!hasSimulation}>
              <ChangeButton onClick={() => onClickToChangePrices()}>
                <img
                  style={{ marginRight: 12 }}
                  src={EditIcon}
                  alt={`Ajustar Preços`}
                />
                <ButtonLabel>Ajustar Preços</ButtonLabel>
              </ChangeButton>
              <ChangeButton onClick={() => onClickToSave && onClickToSave()}>
                <ChangeIcon />
                <ButtonLabel>Guardar Perfil de Simulação</ButtonLabel>
              </ChangeButton>
            </ChangeCol>
          </FiltersList>
          <ShareComponent
            shareContent={`Veja a minha simulação em`}
            shareUrl={`${window.location.origin}${window.location.pathname}?code=${simulationCode}`}
            shareTitle={`Simulação`}
          />
        </Container>
      </Wrapper>
    )
  }
}

const FlexedElectricity = styled(Eletricity)`
  flex: 0.25 !important;
`

const ChangeData = styled.span`
  color: #006736;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  cursor: pointer;
  position: absolute;
  top: -30px;
  margin-left: 20px;
  display: block;
  width: 127%;
`

const BackButton = styled.span`
  font-size: 18px;
`

const FlexedGas = styled(Gas)`
  flex: 0.25 !important;
`

const Flexed = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1200px) {
    flex-direction: column !important;
  }
`

const Wrapper = styled(ShadowBox)`
  height: 180px;
  width: 100%;
  width: 100%;
  margin: 0 auto;
  position: relative;
  top: -100px;
  display: flex;
  margin-bottom: -100px;

  ${({ noSimulation }) =>
    noSimulation &&
    `
    height: 300px;
  `}

  @media(max-width: 1200px) {
    width: 100%;
    flex-direction: column !important;
    height: initial;
  }
`

const FiltersList = styled(Row)`
  margin: 0 !important;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  height: 100%;

  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column !important;
  }

  ${({ noSimulation }) =>
    noSimulation &&
    `
    @media(max-width: 1200px) {
      display: flex;
      flex-direction: column;
    }
  `}
`

const Container = styled(Grid)`
  padding-left: 0 !important;
  padding-right: 0 !important;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;

  @media (max-width: 1200px) {
    margin-left: initial !important;
    margin-right: initial !important;
  }
`

const Scrollable = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: 1200px) {
    max-width: 100%;
    flex-direction: column;
  }
`

const GreyCol = styled.div`
  background-color: #676767;
  flex: 0.2;
  position: relative;

  @media (max-width: 1200px) {
    min-width: 150px;
  }

  ${({ noSimulation }) =>
    noSimulation &&
    `
    background: #fff;
    flex: 2;
  `}
`

const EletricityRow = styled.div`
  display: flex;
  flex-direction: row;
  border-right: 1px solid #f9f9f9;

  @media (max-width: 1200px) {
    margin-right: 0;
    min-width: 165px;
    min-height: 170px;
  }

  @media (max-width: 1000px) {
    border-right: none;
  }

  @media (max-width: 440px) {
    flex-direction: column;
  }
`

const GasRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5%;

  @media (max-width: 1200px) {
    margin-right: 0;
    min-width: 165px;
    min-height: 170px;
  }

  @media (max-width: 440px) {
    flex-direction: column;
  }
`

const SimulationNumber = styled.div`
  height: 56px;
  width: 150px;
  border: 1px solid #efefef;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Simulation = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: -56px;
`

const SimulationLabel = styled.span`
  display: block;
  font-size: 12px;
  color: #676767;
  font-weight: 600;
  line-height: 10px;
  text-align: center;
`

const SimulationNumbery = styled.span`
  color: #93c13e;
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  margin-top: 8px;
`

const Title = styled.span`
  color: #676767;
  font-family: Nunito;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
`

const SimulationTitle = styled.div`
  border: 1px solid #efefef;
  background-color: rgba(255, 255, 255, 0.6);
  width: 197px;
  height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 426px) {
    width: 172px;
  }

  @media (max-width: 340px) {
    display: none;
  }
`

const NoSimTitle = styled.div`
  color: #010101;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  position: relative;
  top: -8px;
  height: 90%;
  display: flex;
  align-items: center;
  padding: 32px;

  @media (max-width: 780px) {
    font-size: 16px;
  }
`

export const FaturaCol = styled.div`
  flex: 0.3;
  position: relative;
  display: flex;
  padding: 15% 20px 0 20px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 150px;

  @media (max-width: 1200px) {
    max-width: none;
    justify-content: initial;
    align-items: initial;
    padding: 0;
  }
`

export const Numbery = styled.span`
  color: white;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  margin: 10px 0;
  margin-top: 0;
`

const SmallNumber = styled(Numbery)`
  font-size: 13px;
`

const Unit = styled.span`
  font-weight: normal;
`

const Price = styled.span``

export const Label = styled.span`
  color: #9c9c9c;
  font-family: Nunito;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
`

const ChangeCol = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-shadow: inset 1px 0 0 0 #efefef;
  cursor: pointer;
  margin-left: auto;
  max-width: 150px;

  @media (max-width: 1200px) {
    flex-direction: row;
    max-width: none;
    margin-left: initial;
    align-items: initial;
  }

  ${({ noSimulation }) =>
    noSimulation &&
    `
    @media(max-width: 1200px) {
      flex-direction: row;
      max-width: none;
      margin-left: initial;
      align-items: initial;
    }
  `}
`

const ChangeButton = styled.button`
  border: 0;
  background: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #efefef;
  border: 1px solid #dedede;
  flex: 1;
  width: 100%;
  padding: 0 15px;
  box-shadow: inset 1px -1px 0 0 #efefef;

  &:last-child {
    box-shadow: none;
  }

  @media (max-width: 1200px) {
    padding: 16px;
  }
`

const ButtonLabel = styled.span`
  display: block;
  text-align: center;
  font-weight: bold;
  color: #3e3e3e;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  text-align: left;
  margin-left: 10px;
  flex: 1;

  @media (max-width: 340px) {
    font-size: 12px;
  }
`

const Numberyx = styled.span`
  color: #676767;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 2px 0;
`

const NumberyxSmall = styled.span`
  font-size: 12px;
  line-height: 12px;
  color: #676767;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 2px 0;
`

const NumberyLabel = styled.span`
  color: #676767;
  font-size: 14px;
  font-weight: 100;

  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
`

const NumberyLabelSmall = styled.span`
  color: #676767;
  font-size: 12px;
  font-weight: 100;

  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
`

const NumberysCol = styled.div`
  flex: 0.25;
  text-align: left;
  margin-left: 35px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 20px;
  min-width: 190px;
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 35px;
    min-width: 290px;
    margin-left: 20px;
  }

  @media (max-width: 1100px) {
    min-width: 220px !important;
  }
`

const GasEntityCol = styled.div`
  flex: 0.25;
  text-align: left;
  padding: 0 0 0 15px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 120px;
  margin-top: 20px;
  align-items: center;

  @media (max-width: 1100px) {
    text-align: center;
  }
`

const EletricityEntityCol = styled.div`
  flex: 0.25;
  text-align: left;
  margin-left: 15px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 95px;
  margin-top: 20px;
  align-items: center;

  @media (max-width: 1100px) {
    min-width: 75px !important;
  }
`

const Entity = styled.img`
  max-height: 50%;
  max-width: 50%;
  display: block;

  @media (max-width: 440px) {
    max-width: 30% !important;
  }
`

const TitleLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin: 20px 0;
  color: #ccc;
  white-space: nowrap;
`

const ResultLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin: 10px 0;
  margin-top: 10px;
  color: ${({ el }) => (el ? `#FF8E2A` : `#00BDED`)};

  span {
    color: #ccc;
  }
`

const ShareComponent = ({ shareUrl, shareContent, shareTitle }) => {
  return (
    <ShareBoxContainer style={{ position: 'relative' }}>
      <ShareBox>
        <div className='sharebox-icon'>
          <svg
            width={24}
            height={26}
            viewBox='0 0 24 26'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M19.333 23.44c-1.142 0-2.077-.918-2.077-2.04 0-.097.006-.186.024-.276a2.017 2.017 0 01.8-1.345 2.07 2.07 0 011.253-.42c1.143 0 2.078.918 2.078 2.041 0 1.122-.935 2.04-2.078 2.04m-14.666-8.4c-1.143 0-2.078-.918-2.078-2.04 0-1.123.935-2.04 2.078-2.04.47 0 .904.155 1.252.42.428.318.728.797.801 1.344.018.09.024.18.024.276 0 .096-.006.186-.024.276a2.016 2.016 0 01-.8 1.344 2.07 2.07 0 01-1.253.42M17.256 4.6c0-1.123.935-2.04 2.077-2.04 1.143 0 2.078.917 2.078 2.04 0 1.122-.935 2.04-2.078 2.04-.47 0-.904-.156-1.252-.42a2.016 2.016 0 01-.801-1.344 1.365 1.365 0 01-.024-.276m2.077 13.2a3.667 3.667 0 00-2.689 1.157l-8.482-4.859a3.624 3.624 0 000-2.196l8.482-4.86a3.666 3.666 0 002.69 1.158C21.355 8.2 23 6.586 23 4.6S21.356 1 19.333 1c-2.022 0-3.666 1.614-3.666 3.6 0 .384.06.75.17 1.098l-8.481 4.86A3.666 3.666 0 004.666 9.4C2.645 9.4 1 11.014 1 13c0 1.985 1.644 3.6 3.667 3.6a3.668 3.668 0 002.689-1.158l8.482 4.86c-.11.348-.171.714-.171 1.098 0 1.985 1.644 3.6 3.666 3.6C21.356 25 23 23.385 23 21.4c0-1.986-1.644-3.6-3.667-3.6'
              fill='#222'
              fillRule='nonzero'
              stroke='#222'
              strokeWidth={0.6}
            />
          </svg>
        </div>
        <div className='sharebox-text'>PARTILHAR RESULTADOS</div>
      </ShareBox>

      <div className='sharebox-dialog'>
        <a
          className='resp-sharing-button__link'
          href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            shareUrl
          )}&quote=${encodeURIComponent(shareContent)}`}
          target='_blank'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm3.6 11.5h-2.1v7h-3v-7h-2v-2h2V8.34c0-1.1.35-2.82 2.65-2.82h2.35v2.3h-1.4c-.25 0-.6.13-.6.66V9.5h2.34l-.24 2z' />
              </svg>
            </div>
          </div>
        </a>

        <a
          className='resp-sharing-button__link'
          href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
            shareContent
          )}&url=${encodeURIComponent(shareUrl)}`}
          target='_blank'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm5.26 9.38v.34c0 3.48-2.64 7.5-7.48 7.5-1.48 0-2.87-.44-4.03-1.2 1.37.17 2.77-.2 3.9-1.08-1.16-.02-2.13-.78-2.46-1.83.38.1.8.07 1.17-.03-1.2-.24-2.1-1.3-2.1-2.58v-.05c.35.2.75.32 1.18.33-.7-.47-1.17-1.28-1.17-2.2 0-.47.13-.92.36-1.3C7.94 8.85 9.88 9.9 12.06 10c-.04-.2-.06-.4-.06-.6 0-1.46 1.18-2.63 2.63-2.63.76 0 1.44.3 1.92.82.6-.12 1.95-.27 1.95-.27-.35.53-.72 1.66-1.24 2.04z' />
              </svg>
            </div>
          </div>
        </a>
        <a
          className='resp-sharing-button__link'
          href={`mailto:?subject=${encodeURIComponent(
            shareTitle
          )}&body=${encodeURIComponent(`${shareContent} ${shareUrl}`)}`}
          target='_self'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--email resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm8 16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8z' />
                <path d='M17.9 8.18c-.2-.2-.5-.24-.72-.07L12 12.38 6.82 8.1c-.22-.16-.53-.13-.7.08s-.15.53.06.7l3.62 2.97-3.57 2.23c-.23.14-.3.45-.15.7.1.14.25.22.42.22.1 0 .18-.02.27-.08l3.85-2.4 1.06.87c.1.04.2.1.32.1s.23-.06.32-.1l1.06-.9 3.86 2.4c.08.06.17.1.26.1.17 0 .33-.1.42-.25.15-.24.08-.55-.15-.7l-3.57-2.22 3.62-2.96c.2-.2.24-.5.07-.72z' />
              </svg>
            </div>
          </div>
        </a>

        <a
          className='resp-sharing-button__link'
          href={`https://wa.me/?text=${encodeURIComponent(
            shareContent
          )} ${encodeURIComponent(shareUrl)}`}
          target='_blank'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height='24'
                width='24'
                viewBox='0 0 24 24'>
                <path d='m12 0c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 3.8c2.2 0 4.2 0.9 5.7 2.4 1.6 1.5 2.4 3.6 2.5 5.7 0 4.5-3.6 8.1-8.1 8.1-1.4 0-2.7-0.4-3.9-1l-4.4 1.1 1.2-4.2c-0.8-1.2-1.1-2.6-1.1-4 0-4.5 3.6-8.1 8.1-8.1zm0.1 1.5c-3.7 0-6.7 3-6.7 6.7 0 1.3 0.3 2.5 1 3.6l0.1 0.3-0.7 2.4 2.5-0.7 0.3 0.099c1 0.7 2.2 1 3.4 1 3.7 0 6.8-3 6.9-6.6 0-1.8-0.7-3.5-2-4.8s-3-2-4.8-2zm-3 2.9h0.4c0.2 0 0.4-0.099 0.5 0.3s0.5 1.5 0.6 1.7 0.1 0.2 0 0.3-0.1 0.2-0.2 0.3l-0.3 0.3c-0.1 0.1-0.2 0.2-0.1 0.4 0.2 0.2 0.6 0.9 1.2 1.4 0.7 0.7 1.4 0.9 1.6 1 0.2 0 0.3 0.001 0.4-0.099s0.5-0.6 0.6-0.8c0.2-0.2 0.3-0.2 0.5-0.1l1.4 0.7c0.2 0.1 0.3 0.2 0.5 0.3 0 0.1 0.1 0.5-0.099 1s-1 0.9-1.4 1c-0.3 0-0.8 0.001-1.3-0.099-0.3-0.1-0.7-0.2-1.2-0.4-2.1-0.9-3.4-3-3.5-3.1s-0.8-1.1-0.8-2.1c0-1 0.5-1.5 0.7-1.7s0.4-0.3 0.5-0.3z' />
              </svg>
            </div>
          </div>
        </a>
      </div>
    </ShareBoxContainer>
  )
}

const ShareBoxContainer = styled.div`
  position: absolute !important;
  top: -75px;
  right: 0;

  @media screen and (max-width: 768px) {
    position: relative;
    top: initial;
    width: 100%;
  }

  .resp-sharing-button__link,
  .resp-sharing-button__icon {
    display: inline-block;
  }

  .resp-sharing-button__link {
    text-decoration: none;
    color: #fff;
    margin: 2px;
  }

  .resp-sharing-button {
    border-radius: 5px;
    transition: 25ms ease-out;
    padding: 0.5em 0.75em;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  }

  .resp-sharing-button__icon svg {
    width: 1em;
    height: 1em;
    margin-right: 0.4em;
    vertical-align: top;
  }

  .resp-sharing-button--small svg {
    margin: 0;
    vertical-align: middle;
  }

  /* Non solid icons get a stroke */
  .resp-sharing-button__icon {
    stroke: #fff;
    fill: none;
  }

  /* Solid icons get a fill */
  .resp-sharing-button__icon--solid,
  .resp-sharing-button__icon--solidcircle {
    fill: #fff;
    stroke: none;
  }

  .resp-sharing-button--twitter {
    background-color: #55acee;
  }

  .resp-sharing-button--twitter:hover {
    background-color: #2795e9;
  }

  .resp-sharing-button--pinterest {
    background-color: #bd081c;
  }

  .resp-sharing-button--pinterest:hover {
    background-color: #8c0615;
  }

  .resp-sharing-button--facebook {
    background-color: #3b5998;
  }

  .resp-sharing-button--facebook:hover {
    background-color: #2d4373;
  }

  .resp-sharing-button--tumblr {
    background-color: #35465c;
  }

  .resp-sharing-button--tumblr:hover {
    background-color: #222d3c;
  }

  .resp-sharing-button--reddit {
    background-color: #5f99cf;
  }

  .resp-sharing-button--reddit:hover {
    background-color: #3a80c1;
  }

  .resp-sharing-button--google {
    background-color: #dd4b39;
  }

  .resp-sharing-button--google:hover {
    background-color: #c23321;
  }

  .resp-sharing-button--linkedin {
    background-color: #0077b5;
  }

  .resp-sharing-button--linkedin:hover {
    background-color: #046293;
  }

  .resp-sharing-button--email {
    background-color: #777;
  }

  .resp-sharing-button--email:hover {
    background-color: #5e5e5e;
  }

  .resp-sharing-button--xing {
    background-color: #1a7576;
  }

  .resp-sharing-button--xing:hover {
    background-color: #114c4c;
  }

  .resp-sharing-button--whatsapp {
    background-color: #25d366;
  }

  .resp-sharing-button--whatsapp:hover {
    background-color: #1da851;
  }

  .resp-sharing-button--hackernews {
    background-color: #ff6600;
  }
  .resp-sharing-button--hackernews:hover,
  .resp-sharing-button--hackernews:focus {
    background-color: #fb6200;
  }

  .resp-sharing-button--vk {
    background-color: #507299;
  }

  .resp-sharing-button--vk:hover {
    background-color: #43648c;
  }

  .resp-sharing-button--facebook {
    background-color: #3b5998;
    border-color: #3b5998;
  }

  .resp-sharing-button--facebook:hover,
  .resp-sharing-button--facebook:active {
    background-color: #2d4373;
    border-color: #2d4373;
  }

  .resp-sharing-button--twitter {
    background-color: #55acee;
    border-color: #55acee;
  }

  .resp-sharing-button--twitter:hover,
  .resp-sharing-button--twitter:active {
    background-color: #2795e9;
    border-color: #2795e9;
  }

  .resp-sharing-button--email {
    background-color: #777777;
    border-color: #777777;
  }

  .resp-sharing-button--email:hover,
  .resp-sharing-button--email:active {
    background-color: #5e5e5e;
    border-color: #5e5e5e;
  }

  .resp-sharing-button--whatsapp {
    background-color: #25d366;
    border-color: #25d366;
  }

  .resp-sharing-button--whatsapp:hover,
  .resp-sharing-button--whatsapp:active {
    background-color: #1da851;
    border-color: #1da851;
  }

  .sharebox-dialog {
    display: none;
    position: absolute;
    left: 65px;
    top: 50%;
    transform: translateY(-50%);
  }

  &:hover {
    .sharebox-dialog {
      display: block;
    }

    .sharebox-text {
      opacity: 0;
    }
  }
`

const ShareBox = styled.div`
  outline: none;
  border: 1px solid #dedede;
  background-color: #efefef;
  color: #676767;
  font-size: 14px;
  font-weight: 300;
  line-height: 19px;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 14px;

  .sharebox-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sharebox-text {
    padding: 0 24px;
    flex: 1;
    color: #010101;
    font-family: Nunito;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
  }

  .sharebox-carrot {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`



// WEBPACK FOOTER //
// ./src/components/TopResult/index.js